import {AfterViewInit, ChangeDetectorRef, Component, DestroyRef, inject, Input, OnInit} from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ActivatedRoute } from '@angular/router';
import { Group } from '../../../models/group';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { finalize } from 'rxjs';
import { PublicService } from '../../../services/public.service';
import { LogService } from '../../../services/log.service';
import _ from 'lodash';

@Component({
  selector: 'app-public-groups',
  imports: [
    ButtonModule,
    TableModule,
    TranslateModule,
  ],
  templateUrl: './public-groups.component.html',
  styleUrl: './public-groups.component.scss',
})
export class PublicGroupsComponent implements OnInit, AfterViewInit {
  private readonly destroy$ = inject(DestroyRef);
  public groups: Group[] = [];
  public loading: boolean = true;
  public tournamentId: string = '';
  @Input() tournamentIdInput: string | undefined;

  constructor(
    private cdr: ChangeDetectorRef,
    private logService: LogService,
    private publicService: PublicService,
    private route: ActivatedRoute,
    private translate: TranslateService,
  ) {}

  ngOnInit(): void {
    if(this.tournamentIdInput) {
      this.tournamentId = this.tournamentIdInput;
    } else {
      this.tournamentId = this.route.snapshot.paramMap.get('id')!;
    }
    this.getTournamentGroups();
  }

  ngAfterViewInit() {
    // resize if content changes
    const observer = new ResizeObserver(() => this.sendGroupsHeight());
    observer.observe(document.body);
  }

  private getTournamentGroups(): void {
    if(!this.tournamentId) return;
    this.publicService.getPublicGroups(this.tournamentId)
      .pipe(
        takeUntilDestroyed(this.destroy$),
        finalize(() => this.loading = false)
      )
      .subscribe({
        next: (res) => {
          this.logService.info('[Group] - getPublicGroups', _.get(res, 'body'));
          this.groups = _.orderBy(_.get(res, 'body.data', []), 'name');
          setTimeout(() => {
            this.cdr.detectChanges();
          });
        },
        error: (err) => {
          this.logService.error('[Group] - getPublicGroups', err, this.translate.instant('error.tournament-groups'));
        }
      });
  }

  private sendGroupsHeight(): void {
    const height = document.body.scrollHeight;
    window.parent.postMessage({ iframeGroupsHeight: height }, '*');
  }
}
